import {
  addNavMenuItem,
  addNavMenuSection,
  Permission,
} from "@bb-vendure/admin-ui/core";

export default [
  addNavMenuSection(
    {
      id: "process",
      label: "nav.process",
      items: [],
    },
    "products-section"
  ),
  // addNavMenuSection(
  //   {
  //     id: "dashboard",
  //     label: "Dashboard",
  //     items: [],
  //   },
  //   "process"
  // ),
  addNavMenuItem(
    {
      id: "audit-request",
      label: "nav.audit-requests",
      routerLink: ["/extensions/audit-requests"],
      icon: "check-circle",
      requiresPermission: (userPermission) => {
        return userPermission.includes("ApproveAuditRequest");
      },
    },
    "process"
  ),
];
